import script from "./Caap101Subjects.vue?vue&type=script&setup=true&lang=js"
export * from "./Caap101Subjects.vue?vue&type=script&setup=true&lang=js"

import "./Caap101Subjects.vue?vue&type=style&index=0&id=5981a2ee&scoped=true&lang=css"

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5981a2ee"]])

export default __exports__